const ACTION_ADD = 'trackAddWatchlist';
const ACTION_REMOVE = 'trackRemoveWatchlist';
const ACTION_ERROR = 'trackErrorWatchlist';

export default class WatchlistTracking {
    constructor(watchlistCta) {
        this._cta = watchlistCta;
        this._om = window.om;
    }

    trackAddAction(params = {}) {
        this._om.trackAction(ACTION_ADD, params);
    }

    trackRemoveAction(params = {}) {
        this._om.trackAction(ACTION_REMOVE, params);
    }

    trackApiError(params = {}) {
        this._om.trackAction(ACTION_ERROR, params);
    }
}
